module.exports = __webpack_public_path__ + "static/media/banner_01_sm.44824bab.jpg";